import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
// Material Imports
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
//  Global Functions
import { dateFormat } from '../../../../api/dateFormat';
// Components
import PopUpModal from '../../../../components/PopUpModal';
import ExamSolutions from '../ExamSolutions';

const useStyles = makeStyles(theme => ({
  table: {
    minWidth: 650
  },
  dialogCustomizedWidth: {
    [theme.breakpoints.up('xs')]: {
      'max-width': '100%'
    },
    [theme.breakpoints.up('sm')]: {
      'max-width': '80%'
    },
    [theme.breakpoints.up('md')]: {
      'max-width': '65%'
    },
    [theme.breakpoints.up('xl')]: {
      'max-width': '65%'
    }
  },
  dialogPosition: {
    position: 'absolute',
    right: '0px',
    top: '0px'
  }
}));

export default function attemptedExamTable(props) {
  const classes = useStyles();
  const childRef = useRef();

  const [selectedDownload, setSelectedDownload] = useState('');

  return (
    <div>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Test Title</TableCell>
              <TableCell>Test Date</TableCell>
              <TableCell>Test Time</TableCell>
              <TableCell>View Paper</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.rows.map(row => (
              <TableRow key={row.TPCID}>
                <TableCell component="th" scope="row">
                  {row.TestTitle}
                </TableCell>
                <TableCell>{dateFormat(row.TestDate)}</TableCell>
                <TableCell>{row.StartTime}</TableCell>
                <TableCell
                  onClick={() => {
                    setSelectedDownload(row.TPCID);
                    childRef.current.handleClickOpen();
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  {/* <Link to={`/exam-hall/${row.TPCID.replace('/', '&frasl;')}`}> */}
                  Click Here
                  {/* </Link> */}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <PopUpModal
        ref={childRef}
        header={''}
        body={<ExamSolutions TPCID={selectedDownload} />}
        width={classes.dialogCustomizedWidth}
        position={classes.dialogPosition}
        fullScreen={true}
      />
    </div>
  );
}

attemptedExamTable.propTypes = {
  rows: PropTypes.array.isRequired
};
